import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, Phone, ArrowUpRight } from "lucide-react";
import { LogoMark } from "@/components/brand/Logo";
import { NAV, CATEGORIES, COMPANY } from "@/data/site";

const Col = ({ title, children }) => (
  <div>
    <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-slate-500">{title}</p>
    <ul className="mt-5 space-y-3 text-sm text-slate-300">{children}</ul>
  </div>
);

export const Footer = () => (
  <footer className="relative overflow-hidden border-t border-white/5 bg-ink-950 pt-20" data-testid="site-footer">
    <div className="container-x grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <LogoMark className="h-12 w-12" />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
          Commercial amusement equipment, installation, service, and support for businesses — from our home base in McMinnville, Tennessee.
        </p>
        <a href={COMPANY.tel} className="mt-8 inline-flex items-center gap-3 font-display text-2xl font-bold text-white transition-colors hover:text-volt" data-testid="footer-phone-link">
          <Phone className="h-5 w-5 text-volt" /> {COMPANY.phone}
        </a>
      </div>
      <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-8">
        <Col title="Explore">
          {NAV.map((n) => (
            <li key={n.to}><Link to={n.to} className="transition-colors hover:text-volt" data-testid={`footer-nav-${n.id}`}>{n.label}</Link></li>
          ))}
        </Col>
        <Col title="Equipment">
          {CATEGORIES.map((c) => (
            <li key={c.slug}><Link to={`/equipment?category=${c.slug}`} className="transition-colors hover:text-volt" data-testid={`footer-cat-${c.slug}`}>{c.title}</Link></li>
          ))}
        </Col>
        <Col title="Visit">
          <li className="flex gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-volt" /><span>{COMPANY.name}<br />{COMPANY.street}<br />{COMPANY.city}</span></li>
          <li><a href={COMPANY.directions} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-volt" data-testid="footer-directions-link">Get directions <ArrowUpRight className="h-3.5 w-3.5" /></a></li>
        </Col>
      </div>
    </div>
    <div className="container-x mt-20 flex flex-col gap-3 border-t border-white/5 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 sm:flex-row sm:justify-between">
      <span>© {new Date().getFullYear()} {COMPANY.name}</span>
      <span>McMinnville, Tennessee</span>
    </div>
    <div aria-hidden className="pointer-events-none flex select-none justify-center overflow-hidden px-2 font-display text-[22vw] font-black leading-[0.78] tracking-[-0.05em] opacity-30">
      {"BREWER".split("").map((c, i) => (
        <motion.span key={i} className="text-outline inline-block" initial={{ y: "100%" }} whileInView={{ y: "0%" }} viewport={{ once: true }} transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: i * 0.07 }}>
          {c}
        </motion.span>
      ))}
    </div>
  </footer>
);
